import { render, staticRenderFns } from "./AccountNum.vue?vue&type=template&id=962c4cd8&scoped=true&"
import script from "./AccountNum.vue?vue&type=script&lang=js&"
export * from "./AccountNum.vue?vue&type=script&lang=js&"
import style0 from "./AccountNum.vue?vue&type=style&index=0&id=962c4cd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962c4cd8",
  null
  
)

export default component.exports